import { UseQuotaModal } from "@shared/features/settings/types";
import { useSharedQuotaModal } from "@shared/features/settings/hooks";
import { displayResultMessage } from "utils/misc";
import QuotaModal from "features/settings/Quota/QuotaModal";
import { IS_WEB_VIEW } from "common/constants.ts";

const useQuotaModal: UseQuotaModal = ({
  usageType,
  onTriggerClick,
  checkImmediately,
  onModalClose,
  isModalCentered,
}) => {
  const { handleTriggerClick, isLoading, ...modalData } = useSharedQuotaModal({
    usageType,
    onTriggerClick,
    checkImmediately,
    onModalClose,
    displayResultMessage,
    isWebView: IS_WEB_VIEW,
  });

  return {
    quotaModal: <QuotaModal {...modalData} centered={isModalCentered} />,
    handleTriggerClick,
    isLoading,
  };
};

export default useQuotaModal;
